import React, { memo } from "react";
import { ItemProps } from "./type";
import s from "./style.module.scss";
import Check from "./icons/Check";

const Item: React.FC<ItemProps> = memo((mall) => {
  const { active, address, id, setActive, title } = mall;

  const handleChange = () => setActive(mall);

  return (
    <li className={`${s.item} ${active?.id === id ? s.active : ""}`}>
      <div className={s.content}>
        <h4>{title}</h4>
        <span className={s.address}>{address}</span>
        {/* <Link to={href} target="_blank">
          Перейти на сайт
        </Link> */}
      </div>

      <div className={s.radio}>
        <input
          type="radio"
          id={`radio-${id}`}
          name="mall"
          checked={active?.id === id}
          onChange={handleChange}
        />
        <label htmlFor={`radio-${id}`}>
          <Check />
        </label>
      </div>
    </li>
  );
});

export default Item;
